module.exports = __webpack_public_path__ + "static/media/adminConsentTeamPlay.4af5b063.svg";